export default __webpack_public_path__ + "static/media/SELLING 1.481ac9f7.png";